import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Header badge that lights up when there are new items/services at the
// student's saved campus since they last opened the hub.
export const StudentHubIcon = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const [campus, setCampus] = useState(() => localStorage.getItem("pula_campus") || "");
  const prev = useRef(null);

  useEffect(() => {
    if (!user || !campus) { setCount(0); return; }
    let alive = true;
    const load = () => {
      const since = localStorage.getItem("pula_student_seen") || "";
      api.get("/student/new-count", { params: { campus, since } }).then(({ data }) => {
        if (!alive) return;
        const n = data.count || 0;
        if (prev.current !== null && n > prev.current) {
          toast.message("New on campus", { description: `${n} new item${n === 1 ? "" : "s"} & services at ${campus}`, action: { label: "View", onClick: () => open() } });
        }
        prev.current = n;
        setCount(n);
      }).catch(() => {});
    };
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
    // eslint-disable-next-line
  }, [user, campus]);

  // keep campus in sync if changed elsewhere in the tab
  useEffect(() => {
    const h = () => setCampus(localStorage.getItem("pula_campus") || "");
    window.addEventListener("pula-campus-changed", h);
    return () => window.removeEventListener("pula-campus-changed", h);
  }, []);

  const open = () => {
    localStorage.setItem("pula_student_seen", new Date().toISOString());
    setCount(0); prev.current = 0;
    navigate("/students/market");
  };

  if (!user || !campus) return null;
  return (
    <button data-testid="nav-studenthub-icon" onClick={open} title={`Student Hub — ${campus}`}
      className="relative flex items-center justify-center w-9 h-9 rounded-full text-pula-ink hover:bg-pula-bg2 transition-colors">
      <GraduationCap className="w-5 h-5" />
      {count > 0 && <span data-testid="studenthub-badge" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-pula-green text-white text-[10px] grid place-items-center">{count > 9 ? "9+" : count}</span>}
    </button>
  );
};
